import React, { Component } from "react";
import PropTypes from "prop-types";
import { v4 } from "uuid";
import ReactTooltip from "react-tooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classcat from "classcat";
import { translate as t } from "../../../infrastructure/translate/localization";

import { findCategoryEmployees } from "../find-category-employees";
import { displayDeleteUploadingEmployeesModal } from "../displays/display-delete-uploading-employees";
import { inviteUploadingEmployees } from "../invite-uploading-employees";
import { displayEmployeeDetails } from "../displays/display-employee-details";
import { selectAllEmployees, selectEmployee } from "../select-employees";
import { displayCategoryEmployees } from "../displays/display-category-employees";
import { changeTaxRegime } from "../update-tax-regime";
import { changeBenefitModel } from "../update-benefit-model";
import { confirm } from "../../../app/components/modals/confirm";
import { translateEmployeeProperties } from "../../../infrastructure/translate/translateEmployeeProperties";

export default class CategoryEmployeeTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pricingType: localStorage.getItem("pricing_type"),
    };
  }

  translateErrors = (word) => {
    const words = {
      "duplicated-email": t("employees-section.duplicated-email"),
      "missing-gross-salary": t("employees-section.missing-gross-salary"),
      "missing-name": t("employees-section.missing-name"),
      "missing-surname": t("employees-section.missing-surname"),
      "invalid-legal-id": t("employees-section.invalid-legal-id"),
      "missing-email": t("employees-section.missing-email"),
      "different-domain-email": t("employees-section.different-domain-email"),
      "inefficient-gross-salary": t(
        "employees-section.inefficient-gross-salary"
      ),
      "invalid-ascii-name": t("employees-section.invalid-ascii-name"),
      "invalid-ascii-surname": t("employees-section.invalid-ascii-surname"),
    };
    return words[word] === undefined
      ? t("common-messages.unknown")
      : words[word];
  };

  render() {
    const {
      category,
      employeeIds,
      uploadingEmployees,
      currentPage,
      pageCount,
      showTable,
      models,
      taxRegimes,
      selected,
    } = this.props;
    const { pricingType, search, value } = this.state;

    return (
      <div>
        {showTable && (
          <div>
            <ReactTooltip
              data-tip-disable
              className="tooltipMessage"
              place="top"
              effect="solid"
              type="light"
              delayShow={500}
            />
            <div className="cob-btn-group">
              <div className="cob-btn-group">
                <div
                  className="cob-checkbox"
                  onClick={() =>
                    selectAllEmployees({
                      ids: employeeIds,
                      cb: () =>
                        displayCategoryEmployees({ category, currentPage }),
                    })
                  }
                  role="presentation"
                >
                  {(selected.length > 0 &&
                    selected.length === employeeIds.length && (
                      <FontAwesomeIcon icon="check" />
                    )) ||
                    (selected.length > 0 && <FontAwesomeIcon icon="minus" />)}
                </div>
                {category === "warning" && (
                  <h3>
                    {t("employees-section.warning-employees")} (
                    {employeeIds.length})
                  </h3>
                )}
                {category === "error" && (
                  <h3>
                    {t("employees-section.error-employees")} (
                    {employeeIds.length})
                  </h3>
                )}
                {category === "uploading" && (
                  <h3>
                    {t("employees-section.ready-employees")} (
                    {employeeIds.length})
                  </h3>
                )}
              </div>
              <div className="cob-btn-group right-group">
                <div className="cob-search">
                  <FontAwesomeIcon icon="search" />
                  <input
                    type="string"
                    placeholder={t("actions.search")}
                    value={search}
                    onChange={(e) =>
                      findCategoryEmployees(category, e.target.value)
                    }
                  />
                </div>
              </div>
            </div>
            {category === "warning" && (
              <p className="table-description">
                {t("employees-section.review-employees")}
              </p>
            )}
            {category === "error" && (
              <p className="table-description">
                {t("employees-section.fix-employees")}
              </p>
            )}
            {category === "uploading" && (
              <p className="table-description">
                {t("employees-section.last-step")}
              </p>
            )}
            <div className="cob-btn-group right-group">
              <span
                data-tip={
                  selected.length === 0
                    ? t("employees-section.select-delete-invited-employee")
                    : ""
                }
                data-tip-disable={false}
              >
                <button
                  type="button"
                  className="little"
                  disabled={selected.length === 0}
                  onClick={() =>
                    displayDeleteUploadingEmployeesModal(
                      t("employees-section.delete-invited-employee-sure"),
                      selected,
                      "warning",
                      currentPage
                    )
                  }
                >
                  <FontAwesomeIcon icon="trash" alt="delete" />
                </button>
              </span>
              {pricingType !== "freemium" && (
                <div className="cob-input-group">
                  <div className="cob-select">
                    <select
                      className="cob-select"
                      disabled={selected.length !== employeeIds.length}
                      onChange={(e) => {
                        const modelId = e.target.value;
                        confirm({
                          message: t(
                            "employees-section.select-benefit-model-sure"
                          ),
                          onConfirm: () =>
                            changeBenefitModel(
                              selected,
                              modelId,
                              () => true,
                              true
                            ),
                        });
                      }}
                      value={value}
                    >
                      <option disabled selected>
                        {t("employees-section.select-benefit-model")}
                      </option>
                      {models.map((model) => {
                        return (
                          <option key={model.id} value={model.id}>
                            {model.name}
                          </option>
                        );
                      })}
                    </select>
                    <FontAwesomeIcon icon="chevron-down" />
                  </div>
                </div>
              )}
              {pricingType !== "freemium" && (
                <div className="cob-input-group">
                  <div className="cob-select">
                    <select
                      className="cob-select"
                      disabled={selected.length === 0}
                      onChange={(e) => {
                        const taxRegime = e.target.value;
                        confirm({
                          message: t(
                            "employees-section.select-tax-regime-sure"
                          ),
                          onConfirm: () =>
                            changeTaxRegime({
                              employeeIds: selected,
                              taxRegime,
                            }),
                        });
                      }}
                      value={value}
                    >
                      <option disabled selected>
                        {t("employees-section.select-tax-regime")}
                      </option>
                      {taxRegimes.map((taxRegime) => (
                        <option key={v4()} value={taxRegime}>
                          {translateEmployeeProperties("taxRegime", taxRegime)}
                        </option>
                      ))}
                    </select>
                    <FontAwesomeIcon icon="chevron-down" />
                  </div>
                </div>
              )}
              {(category === "warning" || category === "uploading") && (
                <button
                  type="button"
                  className="cob-btn btn-primary"
                  disabled={selected.length === 0}
                  onClick={() => inviteUploadingEmployees(selected)}
                >
                  {t("actions.invite")}
                </button>
              )}
            </div>
            <table>
              <thead>
                <tr>
                  <th className="row-select" aria-label="empty-header" />
                  {pricingType !== "freemium" && (
                    <th>{t("common-messages.internal-id")}</th>
                  )}
                  <th>{t("common-messages.name")}</th>
                  <th>{t("common-messages.surnames")}</th>
                  <th>{t("common-messages.email")}</th>
                  <th>{t("common-messages.benefit-model")}</th>
                  {pricingType !== "freemium" && (
                    <th>{t("common-messages.legal-id")}</th>
                  )}
                  <th aria-label="empty-header" />
                </tr>
              </thead>
              <tbody>
                {uploadingEmployees.map((e) => (
                  <tr key={e.id} className={classcat(["container"])}>
                    <tr
                      className={classcat([
                        { "no-border": e.error || e.warning },
                      ])}
                    >
                      <td className="row-select">
                        <div
                          className="cob-checkbox"
                          onClick={() =>
                            selectEmployee({
                              id: e.id,
                              cb: () =>
                                displayCategoryEmployees({
                                  category,
                                  currentPage,
                                }),
                            })
                          }
                          role="presentation"
                        >
                          {selected.includes(e.id) && (
                            <FontAwesomeIcon icon="check" />
                          )}
                        </div>
                      </td>
                      {pricingType !== "freemium" && <td>{e.internalId}</td>}
                      <td>{e.name}</td>
                      <td>{e.surnames}</td>
                      <td>{e.email}</td>
                      <td>{e.benefitModelName}</td>
                      {pricingType !== "freemium" && <td>{e.legalId}</td>}
                      <td className="cob-link">
                        <p
                          className="mayus"
                          onClick={() =>
                            displayEmployeeDetails({
                              employeeId: e.id,
                              currentPage,
                            })
                          }
                          role="presentation"
                        >
                          {t("actions.edit")}
                        </p>
                      </td>
                    </tr>
                    {(e.error || e.warning) && (
                      <tr
                        className={classcat([
                          "message",
                          { warning: e.warning, error: e.error },
                        ])}
                      >
                        <td />
                        {category === "error" && (
                          <td colSpan="6">
                            <FontAwesomeIcon icon="exclamation-circle" />
                            <span>{this.translateErrors(e.error)}</span>
                          </td>
                        )}
                        {category === "warning" && (
                          <td colSpan="6">
                            <FontAwesomeIcon icon="exclamation-circle" />
                            <span>{this.translateErrors(e.warning)}</span>
                          </td>
                        )}
                      </tr>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="pagination left" hidden={pageCount <= 1}>
              <p className="pagination-text">
                {t("common-messages.pag")}{" "}
                <span className="current-page">{currentPage + 1}</span>{" "}
                {t("common-messages.of")} <span>{pageCount}</span>
              </p>
              <div className="page-buttons">
                <button
                  type="button"
                  disabled={currentPage === 0}
                  className="page-item"
                  onClick={() =>
                    displayCategoryEmployees({
                      category,
                      currentPage: currentPage - 1,
                    })
                  }
                >
                  <FontAwesomeIcon icon="angle-left" />
                </button>
                <button
                  type="button"
                  disabled={currentPage === pageCount - 1}
                  className="page-item"
                  onClick={() =>
                    displayCategoryEmployees({
                      category,
                      currentPage: currentPage + 1,
                    })
                  }
                >
                  <FontAwesomeIcon icon="angle-right" />
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

CategoryEmployeeTable.defaultProps = {
  showTable: false,
  uploadingEmployees: [],
  selected: [],
  employeeIds: [],
};

CategoryEmployeeTable.propTypes = {
  category: PropTypes.string.isRequired,
  uploadingEmployees: PropTypes.array,
  currentPage: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  showTable: PropTypes.bool,
  models: PropTypes.array.isRequired,
  taxRegimes: PropTypes.array.isRequired,
  selected: PropTypes.array,
  employeeIds: PropTypes.array,
};
